import { ErrorHandler, Injectable, Injector, NgZone } from '@angular/core';
import { GlobalErrorService } from '../services/shared/global-error.service';
import { environment } from '../../environments/environment';
import { NotificationService } from '../services/shared/notification.service';
import { DialogService } from '@progress/kendo-angular-dialog';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {

  constructor(private injector: Injector, private zone: NgZone) { }

  handleError(error: Error) {
    this.zone.run(() => {
      const errorService = this.injector.get(GlobalErrorService);
      const notifier = this.injector.get(NotificationService);

      let errorMessage;

      if (environment.production == true) {
        errorMessage = errorService.getClientMessage(error);
        console.error('Error occured. For more information, please contact administrator.');
        //notifier.showError('Error occured. For more information, please contact administrator.');

      } else {
        errorMessage = errorService.getClientStack(error);
        console.error('ERROR MESSAGE: ', errorMessage);
        //notifier.showError(errorMessage);
      }
    });
  }
}



// WEBPACK FOOTER //
// c:/Projects/YuDRIV/ServicesAPI/YuDriv-ServicesAPI/Enforcement/src/app/custom/global-error-handler.ts